import Service 							from "./../../Libs/Service";
import { Layout } 						from "./Layout";

let Publisher = new Service({

	Name: "Publisher",

	Libraries: [],

	Events: {

	},

	Actions: {

		//Сервер сообщает о том, что как минимум один паблишер создан (это нужно для обработки настройки feature-single-publisher)
		'PublisherExists': function(isExists) {

			this.isPublisherExists = !!isExists;

			Broadcast.call("Publishers Exists Changed");

		},

		//Получение текущего издателя
		'Publisher': function(publisher) {

			this.setPublisher(publisher);

			this.loaded = true;

			if (!this.SelectedPublisher || this.SelectedPublisher.id !== publisher?.id) this.selectPublisher(publisher?.id);

		},

		//Получение всех издателей для админов
		'Publishers': function(publishers) {

			_.each(publishers, publisher => {

				this.setPublisher(publisher);

			});

			this.loaded = true;

			this.autoSelectPublisher();

			Broadcast.call("Publishers Changed");

		},

		'PublisherContacts': function(publisherContacts) {

			_.each(publisherContacts, publisherContact => {

				this.setPublisherContact(publisherContact);

			});

			Broadcast.call("Customer Contacts Changed");

		}

	},

	init() {

		this.loaded = false;

		this.isPublisherExists = null;

		// Текущий издатель
		this.SelectedPublisher = null;

		// Все издатели для админов
		this.Publishers = {};

		// Обращения клиентов через сайт
		this.PublisherContacts = {};

	},

	setPublisher(publisher, callback) {

		if (publisher) {

			let oldPublisher = this.Publishers[publisher.id];

			this.Publishers[publisher.id] = publisher;

			if (this.SelectedPublisher?.id === publisher.id) {

				this.SelectedPublisher = publisher;

				Broadcast.call("Selected Publisher Data Changed");

			}

			if (oldPublisher) Broadcast.call(`Publisher Changed:${publisher.id}`);

			if (Publisher.SelectedPublisher && Publisher.SelectedPublisher.options && Publisher.SelectedPublisher.options.mainMenu && !Publisher.SelectedPublisher.options.mainMenu.playables && Publisher.SelectedPublisher.options.mainMenu.markers) {

				let i = 0;
				let markerSelected = false;
				let markers = Object.keys(Publisher.SelectedPublisher.options.mainMenu.markers);

				while (!markerSelected && markers.length < i + 1) {

					if (Publisher.SelectedPublisher.options.mainMenu.markers[Object.keys(Publisher.SelectedPublisher.options.mainMenu.markers)[i]]) {

						console.log(markers[i]);

						Layout.setPage('marker', {markers: [markers[i]]});

						markerSelected = true;

					} else {

						i++;

					}

				}

			}

		}

	},

	selectPublisher(publisher_id) {

		this.SelectedPublisher = this.Publishers[publisher_id];

		Layout.setPublisher(publisher_id);

		Broadcast.call("Selected Publisher Changed", [this.SelectedPublisher]);

		window.localStorage.setItem('selected-publisher-id', publisher_id);

	},

	autoSelectPublisher() {

		//Отменяем сброс паблишера при переподключении к серверу
		if (this.SelectedPublisher && this.Publishers[this.SelectedPublisher.id]) return;

		if (window.localStorage.getItem('selected-publisher-id')) {

			let publisher_id = parseInt(window.localStorage.getItem('selected-publisher-id'));

			if (this.Publishers[publisher_id]) return this.selectPublisher(publisher_id);

		}

		this.selectPublisher(1);

	},

	setPublisherContact(publisherContact) {

		if (publisherContact) {

			let oldPublisherContact = this.Publishers[publisherContact.id];

			this.PublisherContacts[publisherContact.id] = publisherContact;

			if (oldPublisherContact) Broadcast.call(`Publisher Contact Changed:${publisherContact.id}`);

		}

	},

	getActivePublisherContactsCount() {

		return _.filter(this.PublisherContacts, publisherContact => publisherContact.active).length;

	}

});

//Делаем объект синглтоном чтобы при импортах возвращался тот же самый экземпляр
if (window.Publisher) Publisher = window.Publisher;
else window.Publisher = Publisher;

export { Publisher }

